import {
  CANCEL,
  DONE,
  FETCH_PRICE_HELP_FULFILLED,
  FETCH_PRICE_HELP_PENDING,
  FETCH_PRICE_HELP_REJECTED,
  FETCH_PRICE_HELP_ABORT,
  FETCH_PRICE_HELP_NEW_REJECTED,
  FETCH_PRICE_HELP_NEW_PENDING,
  FETCH_PRICE_HELP_NEW_FULFILLED
} from '../constants';

export const defaultState = {
  fetched: false,
  fetching: false,
  priceHelpData: {}
};

export default function priceHelpReduce(state = defaultState, action) {
  switch (action.type) {
    case DONE:
    case CANCEL:
      return {
        ...defaultState,
      };

    case FETCH_PRICE_HELP_NEW_FULFILLED:
      return {
        ...state,
        priceHelpData: action.payload.body,
        fetched: true,
        fetching: false,
    };

    case FETCH_PRICE_HELP_NEW_PENDING:
    case FETCH_PRICE_HELP_PENDING:
      return {
        ...state,
        fetching: true,
      };

    case FETCH_PRICE_HELP_FULFILLED: {
      return {
        ...state,
        priceHelpData: action.payload.body,
        fetched: true,
        fetching: false,
      };
    }

    case FETCH_PRICE_HELP_NEW_REJECTED:
    case FETCH_PRICE_HELP_REJECTED:
    case FETCH_PRICE_HELP_ABORT:
      return {
        ...state,
        error: action.payload,
        fetched: true,
        fetching: false,
      };

    default:
      return state;
  }
}
